import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { quarterlyReports } from '../../data/content';
import StrategicShare from './StrategicShare';

const QuarterlyReportCard = () => {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border border-slate-100 dark:border-slate-800">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-brand-red/20">
            <SafeIcon name="FileText" className="w-6 h-6 text-brand-red" />
          </div>
          <h3 className="text-xl font-heading font-bold dark:text-white text-slate-900">Quarterly Insights</h3>
        </div>
        <button className="text-[10px] uppercase font-bold tracking-widest text-brand-red hover:text-brand-dark dark:hover:text-white transition-colors">
          View Archive
        </button>
      </div>

      <div className="space-y-6">
        {quarterlyReports.map((report) => (
          <div 
            key={report.id}
            className="p-5 rounded-xl border border-slate-50 dark:border-slate-800/50 bg-slate-50/50 dark:bg-slate-800/30 hover:border-brand-red transition-all group"
          >
            <div className="flex justify-between items-start mb-3">
              <div>
                <h4 className="font-bold text-slate-900 dark:text-white group-hover:text-brand-red transition-colors">{report.title}</h4>
                <p className="text-[10px] text-slate-500 uppercase font-bold tracking-widest">{report.date} • {report.status}</p>
              </div>
              <div className="flex items-center gap-2">
                <StrategicShare reportTitle={report.title} />
                <button className="p-2 rounded-lg bg-white dark:bg-slate-700 shadow-sm text-slate-400 hover:text-brand-red transition-colors">
                  <SafeIcon name="Download" className="w-4 h-4" />
                </button>
              </div>
            </div>
            <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed italic">
              "{report.keyFinding}"
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuarterlyReportCard;